export enum WhatsNewInitSource {
    UserIntent,
    Oobe
}
